import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ShieldAlert } from "lucide-react";

const faqs = [
  {
    q: "Is SilentScan AI a doctor?",
    a: "No. SilentScan AI is not a doctor and does not diagnose diseases. It promotes health awareness and encourages preventive habits — always consult a healthcare professional for medical decisions.",
  },
  {
    q: "How does it work?",
    a: "Our chatbot asks a few conversational questions about your health and lifestyle. Google Gemini then analyzes your answers to produce a personalized Health Risk Score, tailored recommendations, and a 7-day diet plan.",
  },
  {
    q: "Who can use it?",
    a: "Anyone interested in improving health awareness and making more informed lifestyle decisions. SilentScan AI is designed for adults seeking preventive guidance, not urgent medical care.",
  },
  {
    q: "Is my data private?",
    a: "Yes. Your responses are processed only for your assessment and are never used to identify you. Privacy is a first principle of the product.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-28 md:py-36"
    >
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400 mb-5">
            FAQ
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-[-0.03em] leading-tight">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass-card rounded-2xl px-6 border-none"
            >
              <AccordionTrigger className="text-left text-lg font-medium hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div
          data-testid="medical-disclaimer"
          className="mt-10 glass-card rounded-2xl p-5 flex items-start gap-3"
        >
          <ShieldAlert className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" />
          <p className="text-sm text-zinc-300 leading-relaxed">
            <span className="font-medium text-white">Medical Disclaimer:</span>{" "}
            SilentScan AI is not a doctor and does not diagnose diseases. The
            insights provided are for awareness only. Please consult a licensed
            healthcare professional for medical decisions.
          </p>
        </div>
      </div>
    </section>
  );
}
